<template lang="html">
  <div class="preferential-block">
    <div class="preferential-block-icon" v-if="courseInfo.discountMoney">
      立减{{courseInfo.discountMoney}}元
    </div>
    <div class="preferential-block-main" @click="goto">
      <img :src="courseInfo.image" alt="" >
      <h5>
        {{courseInfo.title}}
      </h5>
      <div class="preferential-block-desc">
        <span>{{courseInfo.count}}人订阅</span>
        <span>￥{{courseInfo.price}}</span>
      </div>
    </div>
    <div class="preferential-block-btn" @click="buy">
      立即抢购
    </div>
  </div>
</template>

<script>
  import os from '@edu-fe/os'

  export default {
  name: 'PreferentialBlock',
  props: ['courseInfo'],
  methods: {
    buy () {
      this.$emit('buy', this.courseInfo)
    },
    goto () {
      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          return os.sdk.view.goto('sign-up', { courseId: this.courseInfo.id })
        }
      }
      this.$router.push({
        path: '/sign-up',
        query: {courseId: this.courseInfo.id, from: 'voucher'}
      })
    }
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.preferential-block {
  width: rem(324);
  height: rem(367);
  padding: rem(21);
  background-color: #fff;
  border-radius: rem(10);
  box-sizing: border-box;
  float: left;
  margin-right: rem(32);
  margin-bottom: rem(32);
  position: relative;
  overflow: hidden;
  &-icon {
    position: absolute;
    width:rem(140);
    height: rem(30);
    line-height: rem(30);
    text-align: center;
    background: url('../../assets/images/preferential-icon.png');
    background-size: 100% 100%;
    background-position: center;
    font-size: rem(14);
    color: #fff;
    transform: rotate(-45deg);
    left: rem(-33);
    top: rem(22.5);
  }
  img {
    width:rem(280);
    height: rem(157);
    border-radius: rem(5);
    box-shadow: 0 rem(2) rem(4) #888888;

  }
  h5 {
    width:rem(280);
    white-space: nowrap;
    overflow: hidden;
  	text-overflow:ellipsis;
    font-size: rem(22);
    font-weight: bolder;
    margin: rem(13) 0;
    line-height: 1.3;
  }
  &-desc {
    font-size: rem(20);
    color: #999;
    width: rem(279);
    > span {
      &:last-child {
        float: right;
        text-decoration: line-through;
      }
    }
  }
  &-btn {
    position: absolute;
    bottom: rem(29);
    left: 50%;
    transform: translateX(-50%);
    width: rem(209);
    height: rem(53);
    border-radius: rem(25);
    font-size: rem(24);
    color: #fff;
    text-align: center;
    line-height: rem(53);
    font-weight: bold;
    background: linear-gradient(to right,#eeb424, #e0931d);
  }
}
</style>
